import { PublicChangelogModal } from '@dmp/shared/public-changelog';
import { useCurrentUser } from '../../hooks/use-current-user';
import { publicChangelogConfig } from '../../public-changelog';
import { useStore } from '../../state/use-store';

export const Changelog = () => {
    const [currentUser] = useCurrentUser();
    const showChangelog = useStore((s) => s.ui.showChangelog);
    const updateUi = useStore((s) => s.actions.updateUi);

    // AuthGate populates the user only after authentication succeeds.
    if (!currentUser) {
        return null;
    }

    return (
        <PublicChangelogModal
            config={publicChangelogConfig}
            isManuallyOpen={showChangelog}
            onClose={() => updateUi({ showChangelog: false })}
        />
    );
};
